import { add, type Duration, format, isSameDay, isToday, isYesterday, sub, subDays } from 'date-fns'
import { pl } from 'date-fns/locale'

export const useDateService = () => {
	const today = new Date()

	const addToToday = (props: Duration) => add(today, props)

	const subFromToday = (props: Duration) => sub(today, props)

	return {
		today,
		addToToday,
		subFromToday,
	}
}

export const formatRelativeDate = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	const now = new Date()

	if (isToday(parsedDate)) {
		return format(parsedDate, 'HH:mm', { locale: pl })
	}
	if (isYesterday(parsedDate)) {
		return `wczoraj, ${format(parsedDate, 'HH:mm', { locale: pl })}`
	}
	if (isSameDay(parsedDate, subDays(now, 2))) {
		return `przedwczoraj, ${format(parsedDate, 'HH:mm', { locale: pl })}`
	}
	return format(parsedDate, 'dd.MM.yyyy HH:mm', { locale: pl })
}

export const formatTime = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	return format(parsedDate, 'HH:mm', { locale: pl })
}

export const formatDatePl = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	return format(parsedDate, 'dd MMM yyyy HH:mm', { locale: pl })
}

export const formatDate = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	return format(parsedDate, 'dd.MM.yyyy', { locale: pl })
}

export const dateToDayMonth = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	return format(parsedDate, 'dd.MM', { locale: pl })
}

export const dateToDayAndMonth = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	return format(parsedDate, 'dd MMM', { locale: pl }).replace(/\b\w/g, l => l.toUpperCase())
}

export const dateToDayMonthYear = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	return format(parsedDate, 'dd.MM.yyyy', { locale: pl })
}

export const dateToWeekday = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	return format(parsedDate, 'EEE', { locale: pl })
}

export const dateToFilterFormat = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	return format(parsedDate, 'yyyy-MM-dd', { locale: pl })
}

export const dateTimeToFilterFormat = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	return format(parsedDate, 'yyyy-MM-dd HH:mm:ss', { locale: pl })
}

export const formatDateToInput = (date: Date | string) => {
	const parsedDate = typeof date === 'string' ? new Date(date) : date
	return format(parsedDate, 'MM/dd/yyyy', { locale: pl })
}
